import { User } from 'lib/models/users/users';
import { Contribution } from './choices/contribution';

export interface ContributorConstructorOpts {
  user: User;
  contribution: Contribution;
}

/**
 * Contributor model representing a user who has contributed to a diagnosis.
 *
 * @author jonmd
 */
export class Contributor {
  public user: User;
  public contribution: Contribution;

  constructor(opts: ContributorConstructorOpts) {
    this.user = opts.user;
    this.contribution = opts.contribution;
  }

  toString(): string {
    return `<Contributor: user=${this.user}, contribution=${this.contribution.label}>`;
  }

  toJson(): { user: any; contribution: string } {
    return {
      user: this.user.toJson(),
      contribution: this.contribution.id
    };
  }

  static fromJson(json: any): Contributor {
    return new Contributor({
      user: User.fromJson(json.user),
      contribution: Contribution.fromKey(json.contribution)
    });
  }
}
